import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, CreditCard } from 'lucide-react';
export function Hero() {
  return <section className="bg-dark-900 pt-10 pb-16 px-4 relative overflow-hidden" data-id="element-118">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-primary/20 rounded-full blur-[120px] pointer-events-none" data-id="element-119"></div>

      <div className="max-w-5xl mx-auto relative z-10 text-center" data-id="element-120">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-121">
          <span className="inline-block text-sm text-cream/70 bg-dark-800 border border-primary/30 rounded-full px-4 py-1 mb-4" data-id="element-122">
            📗 BibliotecaDigital
          </span>
          <h1 className="font-bold text-cream mb-4 text-[22px] md:text-[28px]" data-id="element-123">
            Logra que Tu Hijo Deje el Celular Solo y Conecte con la Realidad en
            7 dias
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="mb-8" data-id="element-124">
          <img src="https://cdn.magicpatterns.com/uploads/c3qm6q5d6AQqGzWNX8gY4N/MOCKUP_NINOS_SIN_PANTALLA_(2).png" alt="MegaPack Niños Sin Pantallas" className="w-full max-w-sm md:max-w-xl mx-auto drop-shadow-2xl" data-id="element-125" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="max-w-2xl mx-auto" data-id="element-126">
          <p className="text-cream/80 md:text-lg mb-6 font-sans text-[16px] font-[600]" data-id="element-127">
            Menos pantalla mas creatividad, actividades listas para usar, juegos
            en familia para reconstruir el vinculo
          </p>

          <a href="#pricing" className="inline-block bg-cta hover:bg-cta-hover text-white font-bold text-lg md:text-xl py-4 px-10 rounded-full shadow-[0_0_25px_rgba(16,185,129,0.4)] transition-all hover:scale-105 active:scale-95 mb-6" data-id="element-128">
            👉QUIERO RECUPERAR SU ATENCIÓN
          </a>

          <div className="flex flex-wrap justify-center gap-6 text-sm text-cream/60" data-id="element-129">
            <div className="flex items-center" data-id="element-130">
              <Shield className="w-4 h-4 mr-1" data-id="element-131" /> Garantía 7 días
            </div>
            <div className="flex items-center" data-id="element-132">
              <Lock className="w-4 h-4 mr-1" data-id="element-133" /> Pago seguro
            </div>
            <div className="flex items-center" data-id="element-134">
              <CreditCard className="w-4 h-4 mr-1" data-id="element-135" /> Mercado Pago
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}